import React from "react";
import { FaEye } from "react-icons/fa";
import {
    COMPLIANCE_APPROVED, COMPLIANCE_REJECTED,
} from "../utilities";
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import { toast } from "react-toastify";


const InvestorReviewDetails = ({
    indivInvFormData,
    investorDatauser,
    onBack,
    onNext,
    onEditStep,
    removeCompletedStep,
    handleViewFile,
    isEKYCReady,
    setCurrentStep
}) => {


    const [role_code, setRoleCode] = useState(Cookies.get("role_code"));
    const [bcrbConsent, setBcrbConsent] = useState(false);

    useEffect(() => {
        if (role_code) {
            const decryptedValueData = decrypt(role_code)
            setRoleCode(decryptedValueData);
        }
    }, [])

    const formatDob = (dob) => {
        if (!dob) return "-";

        const date = new Date(Number(dob));
        if (isNaN(date.getTime())) return "-";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };
    const status = investorDatauser?.kyc?.[0]?.status;
    const kycExpiryDate = investorDatauser?.kyc?.[0]?.kyc_expiry_date;

    const isKycExpiry =
        kycExpiryDate && new Date(kycExpiryDate) < new Date();

    const isApproved = status === COMPLIANCE_APPROVED;
    const reason = investorDatauser?.kyc?.[0]?.admin_notes;

    const truncateWords = (text, limit = 35) => {
        if (!text) return "";

        if (text.length <= limit) return text;

        return text.substring(0, limit) + "...";
    };

    const renderKycStatus = () => {
        if (!investorDatauser?.kyc) return null;


        // if (reason) {
        if (investorDatauser?.kyc?.[0]?.status === COMPLIANCE_REJECTED) {

            return (
                <div className="kyc-status kyc-status-rejected">
                    <div>Status: Rejected</div>

                    <div className="kyc-reason">
                        Reason:
                        <span title={reason}
                            style={{ fontSize: "15px" }}>
                            {truncateWords(reason, 35)}
                        </span>
                    </div>
                </div>
            );
        }


        return null;
    };




    const handleViewSelfie = (url) => {
        if (!url) return;

        if (url.includes("pdf")) {
            window.open(url, "_blank");
        } else if (url.startsWith("image/")) {
            window.open(url, "_blank");
        } else {
            console.warn("Unsupported file type:", url);
            window.open(url, "_blank"); // fallback
        }
    };




    return (
        <div className="kyc-poppins-ui">
            <div className="main-content">
                <div className="content-wrapper">





                    {status !== COMPLIANCE_APPROVED && (
                        <div className="review-header-row">
                            <div className="step-header">
                                <div className="step-title">Review Your Information</div>
                                <div className="step-subtitle">
                                    Please verify all details are correct before submitting your application.
                                </div>
                            </div>
                            <div className="review-status">
                                {renderKycStatus()}
                            </div>
                        </div>
                    )}

                    {status === COMPLIANCE_APPROVED && (
                        <div className="review-approve-header-row">
                            <div className="step-header">
                                <div className="step-title">KYC Form</div>
                            </div>
                        </div>
                    )}

                    <div className="review-grid">
                        <div className="review-section">

                            <h3>
                                Contact Information{" "}
                                {status !== COMPLIANCE_APPROVED && (
                                    <span
                                        className="edit-link"
                                        onClick={() => onEditStep(1)}
                                    >     <i className="fas fa-edit edit-icon"></i>

                                        Edit
                                    </span>
                                )}
                            </h3>
                            <div className="review-item">
                                <span className="label">Full Name:</span>
                                <span className="value" id="reviewName">{indivInvFormData.investor_name || "-"}</span>
                            </div>

                            <div className="review-item">
                                <span className="label">Mobile Number:</span>
                                <span className="value" id="reviewPhone">{indivInvFormData.phone || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Email:</span>
                                <span className="value" id="reviewEmail">{investorDatauser.email || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Gender:</span>
                                <span className="value" id="reviewGender">{indivInvFormData.gender || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Employer/Business:</span>
                                <span className="value" id="reviewEmployer">{indivInvFormData.name_of_employer || "-"}</span>
                            </div>



                        </div>

                        <div className="review-section">

                            <h3>
                                Personal Details{" "}
                                {status !== COMPLIANCE_APPROVED && (
                                    <span
                                        className="edit-link"
                                        onClick={() => onEditStep(1)}
                                    >
                                        <i className="fas fa-edit edit-icon"></i>

                                        Edit
                                    </span>
                                )}
                            </h3>

                            <div className="review-item">
                                <span className="label">Country of Birth:</span>
                                <span className="value" id="reviewCountry">{indivInvFormData.country || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Nationality:</span>
                                <span className="value" id="reviewNationality">{indivInvFormData.nationality || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Country of Residence:</span>
                                <span className="value" id="reviewResidence">{indivInvFormData.country_of_residence || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Investor Company Name:</span>
                                <span className="value" id="reviewInvestorCompanyName">{indivInvFormData.investor_company_name || "-"}</span>
                            </div>

                            <div className="review-item">
                                <span className="label">Annual Income:</span>
                                <span className="value" id="reviewIncome">{indivInvFormData.committed_principal || "-"}</span>
                            </div>

                        </div>

                        <div className="review-section">

                            <h3>
                                Nominee details/PEP Declaration{" "}
                                {status !== COMPLIANCE_APPROVED && (
                                    <span
                                        className="edit-link"
                                        onClick={() => onEditStep(2)}
                                    >
                                        <i className="fas fa-edit edit-icon"></i>
                                        Edit
                                    </span>
                                )}
                            </h3>

                            <div className="review-item">
                                <span className="label">Nominee Name:</span>
                                <span className="value" id="reviewNomineeName">{indivInvFormData.nominee_name || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Date of Birth:</span>
                                <span className="value" id="reviewNomineeDOB">
                                    {indivInvFormData.nominee_dob ? formatDob(indivInvFormData.nominee_dob) : "-"}
                                </span>
                            </div>
                            <div className="review-item">
                                <span className="label">Relationship:</span>
                                <span className="value" id="reviewNomineeRelation">{indivInvFormData.nominee_relationship || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Contact:</span>
                                <span className="value" id="reviewNomineeContact">{indivInvFormData.nominee_contact || "-"}</span>
                            </div>
                            <div className="review-item">
                                <span className="label">Politically Exposed Person:</span>
                                <span className="value" id="reviewIsPep">{indivInvFormData.is_pep || "-"}</span>
                            </div>
                        </div>

                        <div className="review-section">

                            <h3>
                                Documents{" "}
                                {status !== COMPLIANCE_APPROVED && (

                                    <span
                                        className="edit-link"
                                        onClick={() => onEditStep(3)}
                                    >   <i className="fas fa-edit edit-icon"></i>

                                        Edit
                                    </span>
                                )}
                            </h3>
                            <div className="review-item">
                                <span className="label">First ID - {indivInvFormData.idType1}</span>
                                {indivInvFormData.id1FrontName ? (
                                    <span className="value uploaded">
                                        Uploaded
                                        <FaEye
                                            className="eye-color-kyc ms-2"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to view"

                                            onClick={() => handleViewFile("id_front")}

                                        />
                                    </span>
                                ) : (
                                    <span className="value not-uploaded">Not uploaded</span>
                                )}
                            </div>
                            <div className="review-item">
                                <span className="label">Second ID - {indivInvFormData.idType2}</span>
                                {indivInvFormData.id2FrontName ? (

                                    <span className="value uploaded d-flex align-items-center gap-2">
                                        Uploaded

                                        <FaEye
                                            className="eye-color-kyc ms-2"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to view "

                                            onClick={() => handleViewFile("id_front2")}


                                        />
                                    </span>
                                ) : (
                                    <span className="value not-uploaded" > Not uploaded</span>
                                )}
                            </div>
                            <div className="review-item">
                                <span className="label">Bank Statement</span>


                                {indivInvFormData.bank_statement_file_name ? (
                                    <span className="value uploaded">
                                        Uploaded
                                        <FaEye
                                            className="eye-color-kyc ms-2"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to view "

                                            onClick={() => handleViewFile("bank_statement")}


                                        />
                                    </span>
                                ) : (
                                    <span className="value not-uploaded">Not uploaded</span>
                                )}
                            </div>
                            <div className="review-item">
                                <span className="label">Selfie Verification</span>

                                {indivInvFormData.selfie_blob_url ? (
                                    <span className="value uploaded">
                                        Uploaded
                                        <FaEye
                                            className="eye-color-kyc ms-2"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to view "

                                            // onClick={() => handleViewFile("selfie")}
                                            onClick={() =>
                                                isApproved
                                                    ? handleViewSelfie(indivInvFormData.selfie_blob_url)
                                                    : handleViewFile("selfie")
                                            }


                                        />
                                    </span>
                                ) : (
                                    <span className="value not-uploaded">Not uploaded</span>
                                )}

                            </div>

                        </div>
                    </div>


                    {!isApproved && (
                        <>
                            <div
                                style={{
                                    background: "#f9fafb",
                                    border: "2px solid #e5e7eb",
                                    borderRadius: "12px",
                                    padding: "20px",
                                    marginBottom: "20px",
                                }}
                            >
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "12px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: "#374151",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        id="bcrbConsent"

                                        checked={bcrbConsent}
                                        onChange={(e) => setBcrbConsent(e.target.checked)}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            marginTop: "2px",
                                            cursor: "pointer",
                                            flexShrink: 0,
                                        }}
                                    />

                                    <span>
                                        I authorize BenneFin to fetch my credit bureau report or any other third party reports as needed.
                                    </span>
                                </label>
                            </div>
                            <div className="button-group">
                                <button className="btn btn-secondary" onClick={onBack}>← Back</button>
                                <button className="btn btn-primary"
                                    onClick={() => {
                                        if (!bcrbConsent) {
                                            toast.error("Please provide your authorization to submit the application.");
                                            removeCompletedStep(5); // 
                                            return; //  stop submission
                                        }

                                        onNext();
                                    }}
                                    disabled={!isEKYCReady()}
                                >Submit Application</button>

                            </div>

                        </>
                    )}


                </div>
            </div>
        </div>
    );
};

export default InvestorReviewDetails;
